// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Paging-module__navigation___2AkKu","nav":"Paging-module__nav___Yx1PY","nav--narrow":"Paging-module__nav--narrow___1-Q-U","current":"Paging-module__current___3Rg9V"};